export async function getManageAccesses() {
    try {
        const response = await fetch('https://y0ak7d7wq8.execute-api.ap-southeast-1.amazonaws.com/prod/getManageAccesses', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (response.ok) {
            const data = await response.json();
            return data.manage_accesses;
        } else {
            console.error(`Error: Failed to fetch manage accesses. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        console.error('Error: Network or other error occurred while fetching manage accesses.', error);
        return null;
    }
}


export async function putManageAccesses(accessId, accessParameters = {}) {
    const submitData = {
        ...accessParameters  // Spread directly
    };

    try {
        console.log('Submitting updated manage access data:', submitData);

        const response = await fetch(
            `https://dplvthm13c.execute-api.ap-southeast-1.amazonaws.com/prod/putManageAccesses/${accessId}`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(submitData),  // Direct payload
            }
        );

        const result = await response.json();

        if (response.ok) {
            console.log('Manage access updated successfully!', result);
            return { success: true, data: result };
        } else {
            console.error('Error updating manage access:', result);
            return { success: false, error: result };
        }
    } catch (error) {
        console.error('Network or other error occurred while updating manage access:', error);
        return { success: false, error };
    }
}
